<template>
  <div class="tabar">
    <ul>
      <li
        v-for="(item,index) in tabList" :key="index"
        @click="switchTo(item.path)"
        :class="{ active: item.path == $route.path }"
      >
        <img :src="item.path == $route.path ? item.icon_active : item.icon " alt  class="z-index:100;"/>
        {{item.title}}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "tabar",
  data(){
    return{
      tabList: [
        {
          title: "充值额",
          path: "/wallet",
          icon: require("@/assets/images/wallet-img/5.png"),
          icon_active: require("@/assets/images/wallet-img/6.png")
        },
        {
          title: "佣金",
          path: "/wallet/wallet-brokerage",
          icon: require("@/assets/images/wallet-img/1.png"),
          icon_active: require("@/assets/images/wallet-img/2.png")
        },
        {
          title: "收入",
          path: "/wallet/income",
          icon: require("@/assets/images/wallet-img/4.png"),
          icon_active: require("@/assets/images/wallet-img/3.png")
        },
      ],
    }
  },
  components:{
  },
  props:[
    'id'
  ],
  created(){
  },
  methods:{
    switchTo(path) {
      // console.log(path)
      if(path == this.$route.path){
        return
      }
      this.$router.replace(`${path}`);
    }
  }
}
</script>
<style lang="less" scoped>
  .tabar {
    width: 100%;
    height: .97rem;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 100;
    box-shadow: 0rem 0rem 0.05rem 0rem #ececec;
    -webkit-box-shadow: 0rem 0rem 0.05rem 0rem #ececec;
    *{
      border:0;
    }
    ul {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      background: #fff;
      justify-content: space-around;
      // &::after {
      //   position: absolute;
      //   top: 0;
      //   left: 0;
      //   width: 100%;
      //   height: 1px;
      //   background: #999;
      // }
    }
    li {
      width: 100%;
      display: flex;
      // flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      font-size: .2rem;
      font-family: Source Han Sans CN Regular, Source Han Sans CN Regular-Regular;
      font-weight: 400;
      border: 0;
      color: #888888;
      &:first-child{
        img{
          width: .24rem;
          height: .23rem;
        }
      }
      &:nth-child(2){
        img{
          width: .13rem;
          height: .24rem;
        }
      }
      &:last-child{
        img{
          width: .26rem;
          height: .25rem;
        }
      }
      img {
        margin: 5px 0;
        margin-right: .1rem;
      }
      &.active {
        color: #EF8201;
        font-weight: 600;
        font-size: 0.2rem;
        font-family: Source Han Sans CN Regular, Source Han Sans CN Regular-Regular;
      }
    }
  }
</style>